import styled from 'styled-components';

import bg05 from '~/assets/bg-section-05.png';

import arrowLeft from '~/assets/icon-arrow-left.png';
import arrowRight from '~/assets/icon-arrow-right.png';

export const Container = styled.section`
  position: relative;
  .ArrowDown {
    margin-bottom: -90px;
  }
`;

export const Title = styled.h3`
  width: 100%;
  max-width: 1700px;
  padding: 0 10px;
  color: #27357c;
  font-size: 50px;
  font-weight: 900;
  text-shadow: 2px 2px 0 #a8dff4;
  text-align: right;
  margin: 0 auto;
  span {
    display: block;
    text-align: center;
    color: #831d13;
  }
  @media (max-width: 992px) {
    padding: 0 15px;
    font-size: calc(100vw / 15);
  }
  @media (max-width: 540px) {
    font-size: calc(100vw / 18);
  }
  @media (max-width: 500px) {
    font-size: 25px;
  }
`;

export const Videos = styled.ul`
  width: 100%;
  /* display: flex; */
  /* margin: 155px 0 275px; */
  margin: 130px 0 240px;
  background: url(${bg05}) center no-repeat;
  background-size: 102%;
  .slick-list {
    width: 100%;
    padding-top: 25px;
    padding-bottom: 35px;
    .slick-slide {
      & > div {
      }
    }
  }
  .slick-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 3;
    width: 25px;
    height: 40px;
    border: 0;
    background-color: transparent;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    font-size: 0;
    &.slick-prev {
      left: 0;
      margin-left: 10px;
      background-image: url(${arrowLeft});
    }
    &.slick-next {
      right: 0;
      margin-right: 10px;
      background-image: url(${arrowRight});
    }
  }
  li {
    /* flex: 0 0 33.33%;
    max-width: 33%; */
    height: 100%;
  }
  @media (max-width: 992px) {
    margin: 60px 0 275px;
  }
`;
